import CheckCircleBlueIcon from '@assets/icons/learning-overview/task/check-circle-blue.svg';
import CheckCircleIcon from '@assets/icons/learning-overview/task/check-circle-green.svg';
import CheckCircleYellowIcon from '@assets/icons/learning-overview/task/check-circle-yellow.svg';
import CloseIcon from '@assets/icons/learning-overview/task/close-filled-yellow.svg';
import { TASK_STATUS } from '@routes/sidebar/___shared___/components/pathway-menu/constants.ts';
import { TASK_SCALE_TYPE } from '@routes/sidebar/___shared___/constants.ts';
import type { TaskScaleType } from '@routes/sidebar/___shared___/types.ts';
import { ASSESSOR_DECISION } from '@routes/sidebar/learning/___pages___/learning-overview/api/task.api.ts';

export const ATTEMPT_LOG_STATUS = {
    PENDING: TASK_STATUS.PENDING,
    PENDING_EXEMPTION: TASK_STATUS.PENDING_EXEMPTION,
    RECALLED: TASK_STATUS.RECALLED,
    REDO_REQUIRED: TASK_STATUS.REDO_REQUIRED,
    CLOSED: TASK_STATUS.CLOSED,
    EXEMPTED: TASK_STATUS.EXEMPTED,
    EXEMPTION_REJECTED: ASSESSOR_DECISION.ExemptionRejected,
} as const;

export type AttemptLogStatus = (typeof ATTEMPT_LOG_STATUS)[keyof typeof ATTEMPT_LOG_STATUS];

const TWO_POINT_BACKGROUNDS = ['var(--colors-red-450, #E14B53)', 'var(--colors-green-450, #1B8156)'];

export const RATING_BACKGROUNDS: Record<TaskScaleType, string[]> = {
    [TASK_SCALE_TYPE.TwoPointApprove]: TWO_POINT_BACKGROUNDS,
    [TASK_SCALE_TYPE.TwoPointConfidence]: TWO_POINT_BACKGROUNDS,
    [TASK_SCALE_TYPE.FivePointCompetence]: [
        'var(--colors-red-450, #E14B53)',
        'var(--colors-red-450, #E14B53)',
        'var(--colors-grey-450, #828080)',
        'var(--colors-green-450, #1B8156)',
        'var(--colors-green-450, #1B8156)',
    ],
};

export const LOG_TITLE_COLOR_MAPPER: Partial<Record<AttemptLogStatus | 'TEXT_BODY', string>> = {
    [ATTEMPT_LOG_STATUS.PENDING]: 'var(--colors-text-action, #2171C6)',
    [ATTEMPT_LOG_STATUS.PENDING_EXEMPTION]: 'var(--colors-text-warning, #AB7B09)',
    [ATTEMPT_LOG_STATUS.REDO_REQUIRED]: 'var(--colors-text-warning, #AB7B09)',
    [ATTEMPT_LOG_STATUS.CLOSED]: 'var(--colors-text-success, #22A06B)',
    [ATTEMPT_LOG_STATUS.EXEMPTED]: 'var(--colors-text-information, #2171C6)',
    [ATTEMPT_LOG_STATUS.EXEMPTION_REJECTED]: 'var(--colors-text-warning, #AB7B09)',
    TEXT_BODY: 'var(--colors-text-body, #50566E)',
};

export const LOG_HEADER_BACKGROUND_MAPPER: Partial<Record<AttemptLogStatus, string>> = {
    [ATTEMPT_LOG_STATUS.PENDING]: 'var(--colors-surface-information, #F2F8FD)',
    [ATTEMPT_LOG_STATUS.PENDING_EXEMPTION]: 'var(--colors-surface-warning, #FFFBED)',
    [ATTEMPT_LOG_STATUS.RECALLED]: 'var(--colors-surface-information, #F2F8FD)',
    [ATTEMPT_LOG_STATUS.REDO_REQUIRED]: 'var(--colors-surface-warning, #FFFBED)',
    [ATTEMPT_LOG_STATUS.CLOSED]: 'var(--colors-surface-success, #F3FFFA)',
    [ATTEMPT_LOG_STATUS.EXEMPTED]: 'var(--colors-surface-information, #F2F8FD)',
    [ATTEMPT_LOG_STATUS.EXEMPTION_REJECTED]: 'var(--colors-surface-warning, #FFFBED)',
};

export const STATUS_ICON_MAPPER: Partial<Record<AttemptLogStatus, typeof CheckCircleIcon>> = {
    [ATTEMPT_LOG_STATUS.PENDING]: CheckCircleYellowIcon,
    [ATTEMPT_LOG_STATUS.PENDING_EXEMPTION]: CheckCircleYellowIcon,
    [ATTEMPT_LOG_STATUS.RECALLED]: CheckCircleYellowIcon,
    [ATTEMPT_LOG_STATUS.CLOSED]: CheckCircleIcon,
    [ATTEMPT_LOG_STATUS.REDO_REQUIRED]: CloseIcon,
    [ATTEMPT_LOG_STATUS.EXEMPTED]: CheckCircleBlueIcon,
    [ATTEMPT_LOG_STATUS.EXEMPTION_REJECTED]: CloseIcon,
};
